
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bRfUA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7218fd1b3900cbe5e5759b8477131dab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8a20fcaf7f6ffa6e$var$_react = $8a20fcaf7f6ffa6e$var$_interopRequireDefault((parcelRequire("42omo")));

var $8a20fcaf7f6ffa6e$var$_lockLocked = $8a20fcaf7f6ffa6e$var$_interopRequireDefault((parcelRequire("9Q2dU")));

var $8a20fcaf7f6ffa6e$var$_lockFilled = $8a20fcaf7f6ffa6e$var$_interopRequireDefault((parcelRequire("17uVW")));
function $8a20fcaf7f6ffa6e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockFilledIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8a20fcaf7f6ffa6e$var$LockLockedIcon = (props)=>/*#__PURE__*/ $8a20fcaf7f6ffa6e$var$_react.default.createElement($8a20fcaf7f6ffa6e$var$_lockLocked.default, Object.assign({
        name: "LockLockedIcon",
        LEGACY_fallbackIcon: $8a20fcaf7f6ffa6e$var$_lockFilled.default
    }, props));
$8a20fcaf7f6ffa6e$var$LockLockedIcon.displayName = 'LockLockedIconMigration';
var $8a20fcaf7f6ffa6e$var$_default = module.exports.default = $8a20fcaf7f6ffa6e$var$LockLockedIcon;

});


//# sourceMappingURL=lock-locked--lock-filled.572a51f5.js.map
